import { useAccessTokenStore } from '../store/useAccessTokenStore';

export const useAccessToken = () => {
  const token = useAccessTokenStore((state) => state.token);
  const setToken = useAccessTokenStore((state) => state.setToken);
  const clearToken = useAccessTokenStore((state) => state.clear);

  return {
    token,
    setToken,
    clearToken,
    hasToken: Boolean(token),
  };
};
